import { render, staticRenderFns } from "./InputAlternateAction.vue?vue&type=template&id=3b3ccb3d&"
import script from "./InputAlternateAction.vue?vue&type=script&lang=js&"
export * from "./InputAlternateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports